import {
  createComponentExtension,
  createPlugin,
} from '@backstage/core-plugin-api';

// NOTE: the githubMyPrsApiRef factory is registered at the app level in
// packages/app/src/apis.ts, not here. This plugin only contributes a component
// extension (MyOpenPRsCard) mounted inside MyDayPage; Backstage's plugin
// collector only discovers plugins from route-level elements, so a factory
// declared in this plugin's `apis` would never be installed.
export const githubMyPrsPlugin = createPlugin({
  id: 'github-my-prs',
});

/**
 * Card listing the current user's open GitHub PRs across all tracked orgs.
 * Designed to be mounted as a grid item on the My Day page (PAT-425).
 */
export const MyOpenPRsCard = githubMyPrsPlugin.provide(
  createComponentExtension({
    name: 'MyOpenPRsCard',
    component: {
      lazy: () =>
        import('./components/MyOpenPRsCard').then(m => m.MyOpenPRsCard),
    },
  }),
);

/**
 * Card listing open PRs where the current user (or their teams) is a requested
 * reviewer. Includes a personal / teams toggle persisted in localStorage.
 * Designed to be mounted as a grid item on the My Day page (PAT-426).
 */
export const PRsForReviewCard = githubMyPrsPlugin.provide(
  createComponentExtension({
    name: 'PRsForReviewCard',
    component: {
      lazy: () =>
        import('./components/PRsForReviewCard').then(m => m.PRsForReviewCard),
    },
  }),
);
